import { DEFAULT_EMPTY_VALUE } from '../constants';
import { DISTRESS_RESPONSE_STATUS } from '../constants/distressStatus';
import { convertIdToValue, getValueFromConstantObject } from '../details';

export const getDistressResponseStatus = list => {
  return convertIdToValue({
    list,
    key: 'currentStatus',
    constant: DISTRESS_RESPONSE_STATUS,
    defaultValue: DEFAULT_EMPTY_VALUE,
  });
};

export const getDistressResponseStatusId = (value, defaultValue) => {
  return value
    ? getValueFromConstantObject({
        constant: DISTRESS_RESPONSE_STATUS,
        value: value.currentStatus,
        key: 'id',
      })
    : defaultValue;
};
